import { render, staticRenderFns } from "./priceTable.vue?vue&type=template&id=3c66a2fc&scoped=true&"
import script from "./priceTable.vue?vue&type=script&lang=js&"
export * from "./priceTable.vue?vue&type=script&lang=js&"
import style0 from "./priceTable.vue?vue&type=style&index=0&id=3c66a2fc&scoped=true&lang=css&"
import style1 from "./priceTable.vue?vue&type=style&index=1&id=3c66a2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c66a2fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDivider,VIcon,VRow,VTextField})
